import { useContext, useState } from 'react';
import { Box, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppContext } from '@contexts/appContext';

const SurveyMonkey = () => {
  const [open, setOpen] = useState(true);
  const {
    state: { ascdInstitutionSettings, currentInstitution },
  } = useContext(AppContext);

  const surveyUrl = process.env.NEXT_PUBLIC_SURVEY_MONKEY_SURVEY_URL;
  const showSurveyModal =
    ascdInstitutionSettings?.settings?.showSurveyModal ??
    currentInstitution?.settings?.showSurveyModal;

  if (!showSurveyModal || !surveyUrl) return null;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
        <IconButton aria-label="Close survey" onClick={() => setOpen(false)} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ px: 2, pb: 2, height: 500 }}>
        <iframe
          title="Witsby user survey"
          src={surveyUrl}
          width="100%"
          height="100%"
          style={{ border: 0, display: 'block' }}
        />
      </Box>
    </Dialog>
  );
};

export default SurveyMonkey;
